/**
 * Toast Notification System
 * Adapter wrapping BeatUI's NotificationService
 */

import { NotificationService } from '@tempots/beatui'

export type ToastType = 'success' | 'error' | 'warning' | 'info'

const typeToColor: Record<
  ToastType,
  'success' | 'danger' | 'warning' | 'info'
> = {
  success: 'success',
  error: 'danger',
  warning: 'warning',
  info: 'info',
}

const typeToIcon: Record<ToastType, string> = {
  success: 'mdi:check-circle',
  error: 'mdi:alert-circle',
  warning: 'mdi:alert',
  info: 'mdi:information',
}

const defaultDurations: Record<ToastType, number> = {
  success: 5000,
  error: 8000,
  warning: 5000,
  info: 5000,
}

function showToast(
  type: ToastType,
  title: string,
  message?: string,
  duration?: number
): void {
  NotificationService.show(
    {
      title,
      color: typeToColor[type],
      icon: typeToIcon[type],
      dismissAfter: duration ?? defaultDurations[type],
      withCloseButton: true,
    },
    ...(message ? [message] : [])
  )
}

export const toast = {
  success: (title: string, message?: string, duration?: number) =>
    showToast('success', title, message, duration),
  error: (title: string, message?: string, duration?: number) =>
    showToast('error', title, message, duration),
  warning: (title: string, message?: string, duration?: number) =>
    showToast('warning', title, message, duration),
  info: (title: string, message?: string, duration?: number) =>
    showToast('info', title, message, duration),
}

export function clearToasts(): void {
  NotificationService.clear()
}
